import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faAmazon, faApple, faSpotify, faDeezer, faItunes } from '@fortawesome/free-brands-svg-icons';
import Footer from './Footer';

// Original brand colors for platforms
const platformColors = {
  'YouTube': '#FF0000',
  'Spotify': '#1DB954',
  'Apple Music': '#ffffff',
  'iTunes Store': '#FE2D63',
  'Amazon Music': '#FF9900',
  'Deezer': '#FF0095',
};

// Icon mapping for platforms
const platformIcons = {
  'YouTube': faYoutube,
  'Spotify': faSpotify,
  'Apple Music': faApple,
  'iTunes Store': faItunes,
  'Amazon Music': faAmazon,
  'Deezer': faDeezer,
};

// SingleMusic component
const SingleMusic = ({ music }) => (
  <div className="bg-black text-white flex flex-col items-center p-2 sm:p-4 md:p-8 lg:p-12 overflow-y-auto">
    {/* Title of the Album */}
    <h1 className="text-xl sm:text-xl md:text-xl lg:text-3xl font-ettlora mb-2 sm:mb-4 text-center">{music.title}</h1>
    
    {/* Video Thumbnail */}
    <img src={music.thumbnail} alt={music.title} className="w-full sm:max-w-sm md:max-w-md lg:max-w-lg mb-4 sm:mb-6 border border-gray-600 rounded-lg" />
    
    {/* Streaming Platforms */}
    <div className="w-full sm:max-w-sm md:max-w-md lg:max-w-lg overflow-x-auto">
      {['YouTube', 'Spotify', 'iTunes Store', 'Apple Music', 'Amazon Music', 'Deezer'].map((platform, index) => {
        // Construct the link based on the music object
        const platformLink = music[`${platform.toLowerCase().replace(/\s/g, '_')}_link`];

        return (
          <div key={index} className="flex justify-between items-center mb-4 bg-gray-800 p-4 rounded-lg border border-gray-600">
            <div className="flex items-center mb-2 sm:mb-0">
              <FontAwesomeIcon
                icon={platformIcons[platform]}
                style={{ color: platformColors[platform] }}
                className="w-8 h-8 mr-4"
              />
              <span className="text-[14px] sm:text-[12px]">{platform}</span>
            </div>
            {platformLink ? (
              <a href={platformLink} target="_blank" rel="noopener noreferrer">
                <button className="bg-gray-700 text-white font-semibold py-1 px-3 rounded border border-white hover:bg-gray-600">
                  {platform === 'YouTube' ? 'Watch' : 'Listen'}
                </button>
              </a>
            ) : (
              <span className="text-gray-500">Not Available</span> // Message if no link is available
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default SingleMusic;
